export enum HeatPumpIntermediarySuccessMessages {
    Yes = 'HEAT_PUMP_INTERMEDIARY.DEVICE.SUCCESS_MESSAGES.YES',
    No = 'HEAT_PUMP_INTERMEDIARY.DEVICE.SUCCESS_MESSAGES.NO',
    Complete = 'HEAT_PUMP_INTERMEDIARY.INTERMEDIARY.SUCCESS_MESSAGES.COMPLETE',
    Building = 'HEAT_PUMP_INTERMEDIARY.BUILDING.SUCCESS_MESSAGES.COMPLETE'
}
